import React from 'react';
import { Globe, ExternalLink, Calendar } from 'lucide-react';

function formatFullDate(iso) {
  if (!iso) return '—';
  const d = new Date(iso.replace(' ', 'T') + (iso.endsWith('Z') ? '' : 'Z'));
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}

export default function SiteInfoCard({ account }) {
  const hostname = safeHostname(account?.siteUrl);

  return (
    <div className="p-5 rounded-2xl bg-white/[0.02] border border-white/[0.06] h-full flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <div className="text-[11px] font-medium text-gray-500 tracking-wider uppercase">
          Your website
        </div>
        <Globe className="w-4 h-4 text-gray-600" />
      </div>

      <div className="flex-1 flex flex-col gap-3">
        <div>
          <div className="text-[10px] font-medium text-gray-600 tracking-wider uppercase mb-1">
            Site
          </div>
          <div className="text-sm text-white">{account?.name || '—'}</div>
        </div>

        <div>
          <div className="text-[10px] font-medium text-gray-600 tracking-wider uppercase mb-1">
            Live URL
          </div>
          {account?.siteUrl ? (
            <a
              href={account.siteUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-sm text-gray-200 hover:text-[#B0FC38] transition-colors"
            >
              {hostname}
              <ExternalLink className="w-3 h-3" />
            </a>
          ) : (
            <span className="text-sm text-gray-600">Not linked yet</span>
          )}
        </div>
      </div>

      <div className="mt-auto pt-4 flex items-center gap-1.5 text-[11px] text-gray-500">
        <Calendar className="w-3 h-3" />
        Last updated {formatFullDate(account?.updatedAt)}
      </div>
    </div>
  );
}

function safeHostname(url) {
  if (!url) return null;
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}
